import React, { useState } from 'react';

import styled from 'styled-components';

import { getUrlDocument, isMediaPreviewableInIframe, getFileTypeIcons, isVideoFile, isImageFile } from '@libs/NwUtils';

import NwIcon from '@components/Gui/NwIcon';
import VideoPlayer from '@components/Gui/VideoPlayer';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2rem;

    .arrow-icon {
        font-size: 48px;
        &:hover {
            color: black;
        }
    }
`;

const MediaContainer = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 32px;

    &.media-container-image {
        height: calc(100vh - 250px);
    }

    &.media-container-video {
        height: calc(100vh - 250px);
        width: 100%;
    }

    img {
        opacity: ${(props) => props.noDisplay && 0};
        height: ${(props) => props.imgType === 'portrait' && `100%`};
        width: ${(props) => props.imgType === 'landscape' && `100%`};

        box-shadow: 0px 2px 8px rgb(0 0 0 / 40%);
    }
`;

const DocumentItemThumbStyle = styled.div`
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
    svg {
        width: 50% !important;
        height: auto;
    }
`;

const MediaPreviewContent = ({ document, iFrameHeight }) => {
    const [dimensions, setDimensions] = useState(null);

    const onImgLoad = ({ target: img }) => {
        setDimensions({ height: img.offsetHeight, width: img.offsetWidth });
    };

    if (document.Provider === 'Youtube' || document.Provider === 'Vimeo' || isVideoFile(document.Extension)) {
        return (
            <MediaContainer className="media-container-video">
                <VideoPlayer document={document} />
            </MediaContainer>
        );
    } else if (isImageFile(document.Extension)) {
        return (
            <MediaContainer
                className="media-container-image"
                noDisplay={!dimensions ? true : false}
                imgType={dimensions && dimensions.height >= dimensions.width ? 'portrait' : 'landscape'}
            >
                <img onLoad={onImgLoad} src={document.Standard.Url} alt="" />
            </MediaContainer>
        );
    } else if (isMediaPreviewableInIframe(document.Extension)) {
        return (
            <iframe
                src={getUrlDocument(document)}
                width="100%"
                style={{ height: iFrameHeight, width: '100%' }}
            ></iframe>
        );
    } else {
        return (
            <MediaContainer className="media-container-file">
                <DocumentItemThumbStyle>
                    <NwIcon icon={getFileTypeIcons(document.Extension)} />
                </DocumentItemThumbStyle>
                <div>
                    <a href={getUrlDocument(document)} target="_blank" rel="noopener noreferrer">
                        <NwIcon icon={byPrefixAndName.fasl['arrow-to-bottom']} style={{ marginRight: 8 }} />
                        <span>Download file</span>
                    </a>
                </div>
            </MediaContainer>
        );
    }
};

const MediaPreview = ({ document, onSelectMediaBefore, onSelectMediaAfter, fullHeight = false, pdfPath }) => {
    const iFrameHeight = fullHeight ? 'calc(100vh - 100px)' : 'calc(80vh - 80px)';

    return (
        <Container>
            {onSelectMediaBefore && (
                <NwIcon
                    pointer
                    className="arrow-icon"
                    icon={byPrefixAndName.fasl['chevron-left']}
                    style={{ marginRight: 16 }}
                    onClick={onSelectMediaBefore}
                />
            )}
            {pdfPath ? (
                <iframe src={pdfPath} width="100%" style={{ height: iFrameHeight, width: '100%' }}></iframe>
            ) : (
                <MediaPreviewContent document={document} iFrameHeight={iFrameHeight} />
            )}
            {onSelectMediaAfter && (
                <NwIcon
                    className="arrow-icon"
                    icon={byPrefixAndName.fasl['chevron-right']}
                    pointer
                    style={{ marginLeft: 16 }}
                    onClick={onSelectMediaAfter}
                />
            )}
        </Container>
    );
};

export default MediaPreview;
